<template>
    <div class="p-3">
        <app-header class="mb-3" title="经纪人解绑的MMSI"/>
        <div v-if="loading" class="text-center w-100">
            <b-spinner label="Spinner"></b-spinner>
        </div>
        <template v-else>
            <div v-if="!items.length" class="text-center p-2 w-100">没有MMSI解绑记录</div>
            <table v-else class="table table-bordered table-striped text-center">
                <tr>
                    <th>序号</th>
                    <th>修改人</th>
                    <th>修改时间</th>
                    <th>中文船名</th>
                    <th>英文船名</th>
                    <th>MMSI</th>
                </tr>
                <tr v-for="(item, index) in items" :key="item.id">
                    <td>{{index + 1}}</td>
                    <td>{{item.userName}}</td>
                    <td>{{item.createTime | momentFormat}}</td>
                    <td>
                        <a v-if="item.seniorHash" class="anchor" target="_blank"
                           :href="'/voyage.html?hash=' + item.seniorHash + '&origin=blank'">
                            {{item.chnName}}
                        </a>
                        <span v-else>{{item.chnName}}</span>
                    </td>
                    <td>{{item.shortName}}</td>
                    <td>{{item.mmsi}}</td>
                </tr>
            </table>
        </template>
    </div>
</template>

<script>
import AppHeader from "../components/AppHeader";
import VesselMmsi from "../services/vesselMmsi";

export default {
    name: "VesselMmsiDeny",
    components: {AppHeader},
    data() {
        return {
            items: [],
            loading: true,
        };
    },
    methods: {
        async load() {
            try {
                this.loading = true;
                this.items = await VesselMmsi.listUnbind();
            } finally {
                this.loading = false;
            }
        },
    },
    created() {
        this.load();
    },
}
</script>

<style scoped>

</style>
